import { Link } from 'react-router-dom';
import type { Table } from '@shared/types';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import './TableCard.css';

interface TableCardProps {
  table: Table;
  onDelete: (tableId: string) => void;
  isDeleting?: boolean;
}

export function TableCard({ table, onDelete, isDeleting }: TableCardProps) {
  return (
    <Card className="table-card">
      <div className="table-card__header">
        <h3 className="table-card__name">{table.name}</h3>
        {table.location && <p className="table-card__location">📍 {table.location}</p>}
      </div>

      <div className="table-card__qr-codes">
        <p className="table-card__qr-label">QR Codes:</p>
        <div className="table-card__qr-list">
          <span className="table-card__qr-badge">Central</span>
          <span className="table-card__qr-badge">Jogador 1</span>
          <span className="table-card__qr-badge">Jogador 2</span>
        </div>
      </div>

      <div className="table-card__actions">
        <Link to={`/admin/tables/${table.id}/buttons`}>
          <Button variant="secondary" size="sm">
            Gerenciar Botões
          </Button>
        </Link>
        <Link to={`/admin/tables/${table.id}/edit`}>
          <Button variant="secondary" size="sm">
            Editar
          </Button>
        </Link>
        <Button
          variant="danger"
          size="sm"
          onClick={() => onDelete(table.id)}
          disabled={isDeleting}
        >
          {isDeleting ? 'Excluindo...' : 'Excluir'}
        </Button>
      </div>
    </Card>
  );
}
